import { LOCATION_COPY } from "./locationMessages";
import { LOCATION_OPTIONS, LOCATION_STATES } from "./locationState";

export const readGeolocationPermission = async (navigatorObject = navigator) => {
  if (!navigatorObject?.geolocation) return LOCATION_STATES.UNAVAILABLE;
  if (!navigatorObject.permissions?.query) return LOCATION_STATES.PROMPT;
  try {
    const permission = await navigatorObject.permissions.query({ name: "geolocation" });
    return ["granted", "denied", "prompt"].includes(permission?.state) ? permission.state : LOCATION_STATES.PROMPT;
  } catch { return LOCATION_STATES.PROMPT; }
};

export const geolocationError = error => {
  if (error?.code === 1) return { kind: LOCATION_STATES.DENIED, message: LOCATION_COPY.errors.denied };
  if (error?.code === 2) return { kind: LOCATION_STATES.UNAVAILABLE, message: LOCATION_COPY.errors.unavailable };
  if (error?.code === 3) return { kind: "timeout", message: LOCATION_COPY.errors.timeout };
  return { kind: LOCATION_STATES.ERROR, message: LOCATION_COPY.errors.error };
};

export const createGeolocationRequester = (navigatorObject = navigator, windowObject = window) => {
  let inFlight = null;
  return (options = LOCATION_OPTIONS) => {
    if (inFlight) return inFlight;
    inFlight = new Promise(resolve => {
      const hostname = windowObject?.location?.hostname;
      if (windowObject?.isSecureContext === false && hostname !== "localhost" && hostname !== "127.0.0.1") {
        resolve({ ok: false, kind: LOCATION_STATES.INSECURE, message: LOCATION_COPY.errors.insecure }); return;
      }
      if (!navigatorObject?.geolocation) {
        resolve({ ok: false, kind: LOCATION_STATES.UNAVAILABLE, message: LOCATION_COPY.errors.unsupported }); return;
      }
      navigatorObject.geolocation.getCurrentPosition(
        position => resolve({ ok: true, position }),
        error => resolve({ ok: false, ...geolocationError(error) }),
        options,
      );
    }).finally(() => { inFlight = null; });
    return inFlight;
  };
};
